import { SUPER_ADMIN } from "@/constants/roles";
import { store } from "@/store/store";
import moment from "moment";

const EMAIL_REGEX: RegExp = new RegExp(/\S+@\S+\.\S+/);

export const EMAIL_VALIDATOR = (value: string) =>
  EMAIL_REGEX.test(value) ? "" : "Please enter a valid email.";

export const isAuthorize = (requiredRoles: string[] | undefined) => {
  if (!requiredRoles || !requiredRoles.length) return true;

  const userState = store?.getState()?.user;

  if (!userState?.user?.roles?.length) return false;
  const roles = userState.user.roles;

  if (roles.includes(SUPER_ADMIN)) return true;
  for (let role of roles) {
    const idx = requiredRoles?.findIndex((reqRole: string) => reqRole === role);
    if (idx !== -1) {
      return true;
    }
  }
  return false;
};

export const convertDateString = (date?: string) => {
  if (!date) return "";
  return moment(date).format("DD-MM-YYYY hh:mm A");
};

export const convertDateTime = (date?: Date) => {
  if (!date) return "";
  return moment(date).format("DD-MM-YYYY hh:mm A");
};
export const convertDateWithoutTimeString = (date?: string) => {
  if (!date) return "";
  return moment(date).format("DD-MM-YYYY");
};

export const isTouchScreen = (): boolean => {
  return window.matchMedia("(pointer: coarse)").matches;
};

export const clearLocalStorageExcept = (keysToKeep: string[]) => {
  // Save values to keep
  const savedValues: Record<string, string> = {};

  keysToKeep.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      savedValues[key] = value;
    }
  });

  // Clear everything
  localStorage.clear();

  // Restore preserved values
  Object.entries(savedValues).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
